var _excluded = ["component", "values", "disabled", "onChange", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { CheckboxGroupContainer } from './CheckboxGroup.style';

var CheckboxGroup = _ref => {
  var {
    component = 'div',
    values = [],
    disabled = false,
    onChange,
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var [selectedValues, setSelectedValues] = React.useState(values);

  var handleCheckboxChange = ev => {
    var element = ev.target;
    var isChecked = element === null || element === void 0 ? void 0 : element.checked;
    var value = element === null || element === void 0 ? void 0 : element.value;
    var newSelectedValues = isChecked ? [...selectedValues, value] : selectedValues.filter(selectedValue => selectedValue !== value);
    setSelectedValues(newSelectedValues);
  };

  React.useEffect(() => {
    onChange === null || onChange === void 0 ? void 0 : onChange(selectedValues);
  }, [selectedValues, onChange]);
  return /*#__PURE__*/React.createElement(CheckboxGroupContainer, _extends({
    as: component
  }, props), React.Children.map(children, child => /*#__PURE__*/React.cloneElement(child, {
    checked: selectedValues.includes(child.props.value) || !!child.props.checked,
    value: child.props.value,
    disabled: disabled || child.props.disabled,
    onChange: handleCheckboxChange
  })));
};

export { CheckboxGroup };
//# sourceMappingURL=CheckboxGroup.js.map